<template>
  <router-view />
</template>
<script>
  export default {
    name: 'CalculoModule',
  }
</script>
